(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  const productRecommendationsSection =$(".product-recommendations")
  const url = productRecommendationsSection.data('url');
  function productRecommendation(){
     $.ajax({
        url: url,
        method: 'GET',
        // dataType: 'json',
        success: function(response) {
          const html = $('<div>').html(response);
          const recommendations = $(html).find('.product-recommendations');
          	if (recommendations && $.trim($(recommendations).html()).length) {
                $(productRecommendationsSection).html($(recommendations).html());
            }
        },
        error: function(error) {
          console.log("Product Recommendation Error:", error);
        }
      });
  }
   productRecommendation()

  } catch(e) { console.error(e); }
})();
})();
